module.exports = __webpack_public_path__ + "img/fi-rr-shopping-bag.9f16040b.svg";